
import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'Navigation' })
export default class Navigation extends Vue {
  private drawer = false;

  private items = [
    { title: 'Dashboard', icon: 'mdi-view-dashboard' },
    { title: 'Photos', icon: 'mdi-image' },
    { title: 'About', icon: 'mdi-help-box' },
  ];

  private color = 'primary';

  private colors = ['primary', 'blue', 'success', 'red', 'teal'];

  private right = false;

  private permanent = true;

  private miniVariant = false;

  private expandOnHover = false;

  private background = false;

  get bg(): string | undefined {
    return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined;
  }
}
